import AmountItem from "./AmountItem";
import LineItem from "./LineItem";
import { currencyFormatter } from "../../../utils/format";
import { useContext, useMemo } from "react";
import PaymentContext from "../../../store/PaymentContext";
import ButtonPrimaryOutline from "../../Button/ButtonPrimaryOutline";

const InvoiceRent = () => {
    const { rentSurchargeFee, rentTotal, rentDepositFee, rentTransportFee }: any = useContext(PaymentContext)

    return (
        <div className="cart-box rounded">
            <div className="relative h-full">
                <div className="heading text-lg px-4">
                    HÓA ĐƠN THUÊ (tạm tính)
                </div>
                <div className="flex justify-between flex-col box-right-item">
                    <div className="amount-items px-4">
                        <LineItem />
                        <AmountItem
                            label={"Tiền đơn thuê"}
                            value={rentTotal}
                            className={"pt-4"}
                        />
                        <AmountItem
                            label={`Tiền phụ thu`}
                            value={rentSurchargeFee}
                            className={""}
                        />
                        <AmountItem
                            label={"Phí vận chuyển"}
                            value={rentTransportFee}
                            className={"mb-4"}
                        />
                        <LineItem />

                        <AmountItem
                            label={"Tổng cộng"}
                            value={rentTotal + rentSurchargeFee + rentTransportFee}
                            isCurrency={true}
                            className={"pt-4 color-danger bold"}
                        />

                        <AmountItem
                            label={"Tiền đảm bảo"}
                            value={rentDepositFee}
                            className={"pb-4"}
                        />

                    </div>

                    <div className="footer-amount">
                        <div className="term-of-payment">
                            <div className="bold text-center title">
                                Tiền đảm bảo
                            </div>
                            <div>
                                Tiền đảm bảo với trường hợp thuê đồ, sẽ đảm bảo cho cửa hàng tránh rủi ro không đáng có, tiền đảm bảo sẽ được hoàn trả sau khi bạn sử dụng dịch vụ thuê đồ của HoaiGiangShop
                            </div>
                            <div className="text-right mt-2">
                                <ButtonPrimaryOutline className="btn-sm">
                                    Liên hệ
                                </ButtonPrimaryOutline>
                            </div>
                        </div>
                        <div className="total_box pb-2 px-4">
                            <div className={`flex justify-between bold`}>
                                <span>Tổng</span>
                                <span className="total_amount">{currencyFormatter.format(rentTotal + rentSurchargeFee + rentDepositFee + rentTransportFee)}</span>

                            </div>
                        </div>
                        {/*<AmountItem*/}
                        {/*    label={"Số tiền còn lại cần thanh toán"}*/}
                        {/*    value={'5'}*/}
                        {/*/>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceRent;
